module.exports = __webpack_public_path__ + "static/media/matthias-tillen-F9zzXiYhJ54-unsplash.ed84c0ee.jpg";